export default "__VITE_ASSET__B1sx01pz__"